import Keycloak from 'keycloak-js';
import Config from "./config";

// Initialisation de Keycloak avec vos paramètres
const keycloak = new Keycloak({
    url: Config.keycloak.url,
    realm: Config.keycloak.realm,
    clientId: Config.keycloak.clientId,
    onLoad: 'login-required', // Demande l'identification automatiquement
    checkLoginIframe: false, // Désactive le rafraîchissement par iframe
    redirectUri: "window.location.origin/missions",
    // silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
});

// keycloak.init({
//     onLoad: 'login-required',
//     KeycloakResponseType: 'code',
//     silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
//     checkLoginIframe: false,
//     pkceMethod: 'S256'
// }).then((auth) => {
//     if (!auth) {
//         window.location.reload();
//     } else {
//         console.info("Authenticated");
//         console.log('auth', auth)
//         console.log('Keycloak', keycloak)
//         keycloak.onTokenExpired = () => {
//             console.log('token expired')
//         }
//     }
// }, () => {
//     console.error("Authenticated Failed");
// });

export default keycloak;
